import React from 'react'
import PropTypes from 'prop-types'
import { Routes, Route } from 'react-router-dom'
import { Layout } from 'antd'

import { ErrorBoundary } from '../../Shared/ErrorBoundary'
import { observer } from 'mobx-react-lite'
import { Notifications } from './Notifications'

// Pages
import { flattenRoutesList } from '../../../config/routes'
import { useStores } from '../../../cls/stores/MobXProvider'
import Page404 from '../../../pages/general/404Page'
import Modified from '../../../pages/platform/Users/helpers/Modified'
import PageSeo from '../../Power/PageSeo'
import { contentStyle } from '../../../design/app-style-config'
import '../../../design/App.css'

const { Content } = Layout

const MainContent = observer(() => {
	const { users, appType } = useStores()
	const { appIsClient, appIsTeam } = appType

	// add is logged in check for RequestModal
	return (
		<Content style={contentStyle}>
			<Routes>
				{flattenRoutesList.map((route) => {
					if (!route?.forceRegisterRoute) {
						// Perform the checks for rules related to login status
						if (route.loggedInDisable && users.isLoggedIn)
							return null
						if (route.loggedInActive && !users.isLoggedIn)
							return null
					}
					if (
						route.appType &&
						route.appType === 'client' &&
						!appIsClient
					)
						return null
					if (route.appType && route.appType === 'team' && !appIsTeam)
						return null
					if (route.published === false) return null
					if (route.notRoute) return null
					// Render the route if it passes all checks
					return (
						<Route
							key={route.key}
							path={route.path + (route?.pathWithChild || '')}
							element={
								<ErrorBoundary>
									<>
										<PageSeo
											seo={route?.seo}
											path={route.path}
										/>
										<route.component />
									</>
								</ErrorBoundary>
							}
						/>
					)
				})}

				<Route path="*" element={<Page404 />} />
			</Routes>

			<Notifications />
			<Modified />
		</Content>
	)
})

MainContent.propTypes = {
	collapsed: PropTypes.bool,
	setCollapsed: PropTypes.func
}

export default MainContent
